/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_Faq_A4Inputs */

const en_guide_json_rest_api_faq_a4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match the HTTP status to the situation, such as 400 for a bad request or 404 for a missing resource, and put the details in a consistent JSON error object. The status tells clients what happened, and the body explains why.`)
};

const ko_guide_json_rest_api_faq_a4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 요청은 400, 없는 리소스는 404처럼 상황에 맞는 HTTP 상태를 쓰고, 세부 내용은 일관된 JSON 오류 객체에 담으세요. 상태 코드는 무슨 일이 일어났는지 알려주고, 본문은 그 이유를 설명합니다.`)
};

const ja_guide_json_rest_api_faq_a4 = /** @type {(inputs: Guide_Json_Rest_Api_Faq_A4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不正なリクエストは400、存在しないリソースは404のように、状況に合った HTTP ステータスを使い、詳細は一貫した JSON エラーオブジェクトに入れましょう。ステータスは何が起きたかを伝え、本文はその理由を説明します。`)
};

/**
* | output |
* | --- |
* | "Match the HTTP status to the situation, such as 400 for a bad request or 404 for a missing resource, and put the details in a consistent JSON error object. T..." |
*
* @param {Guide_Json_Rest_Api_Faq_A4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_faq_a4 = /** @type {((inputs?: Guide_Json_Rest_Api_Faq_A4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_Faq_A4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_faq_a4(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_faq_a4(inputs)
	return ja_guide_json_rest_api_faq_a4(inputs)
});